import React from "react";
import "./Landing.css";
import { Routes, Route, useLocation } from "react-router-dom";

import Layout from "./Layout";
import ContactUs from "./pages/ContactUs/ContactUs";
import Education from "./pages/Education/Education";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs/AboutUs";
import FAQ from "./pages/FAQ/FAQ";
import TNC from "./pages/TNC/TNC";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import BenefitsPage from "./pages/Benefits/Benefits";
import { useEffect } from "react";

export default function Landing() {
  const ScrollToTop = () => {
    const location = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);

    return null; // This component does not render anything
  };
  return (
    <div className="landing-container">
      <div style={{ backgroundColor: "white" }}>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about-us" element={<AboutUs />} />
            <Route path="contact-us" element={<ContactUs />} />
            <Route path="education" element={<Education />} />
            <Route path="faqs" element={<FAQ />} />
            <Route path="tnc" element={<TNC />} />
            <Route path="Privacy" element={<PrivacyPolicy />} />
            <Route path="Benefits" element={<BenefitsPage />} />
          </Route>
        </Routes>
      </div>
    </div>
  );
}
